import { useCallback } from 'react';
import { useCheckOutFlowParams } from 'hooks/useCheckOutFlowParams';
import { useCheckOutTraysBySet } from 'hooks/useCheckOutTraysBySet';
import { useVisibleCheckOutDialog } from 'hooks/useVisibleCheckOutDialog';

const useExitCheckOutFlow = () => {
  const { setVisibleCheckOutDialog } = useVisibleCheckOutDialog();
  const setCheckOutTraysBySet = useCheckOutTraysBySet()[1];
  const { resetCheckOutFlowParams, setCheckOutFlowParam } = useCheckOutFlowParams();

  return useCallback(
    (exitSurgeryFlow = true) => {
      setVisibleCheckOutDialog(null);
      setCheckOutTraysBySet({});
      if (exitSurgeryFlow) resetCheckOutFlowParams();
      else setCheckOutFlowParam('flowExited', true);
    },
    [resetCheckOutFlowParams, setCheckOutFlowParam, setCheckOutTraysBySet, setVisibleCheckOutDialog],
  );
};

export default useExitCheckOutFlow;
